import { TimePicker, TimePickerProps } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from 'react';
import DatePicker from "react-datepicker";
import { Link } from 'react-router-dom';
import Select, { StylesConfig } from "react-select";


const MeetingSidebar = ({ activityTogglePopup, closeSidebar,isEditing }:any) => {
    dayjs.extend(customParseFormat);
   const onChangeStart: TimePickerProps['onChange'] = (time, timeString) => {
};
const onChangeEnd: TimePickerProps['onChange'] = (time, timeString) => {
  };
    const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(new Date());
    const handleStartDateChange = (date: Date | null) => {
        setSelectedStartDate(date);
    };
    const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(new Date());
    const handleEndDateChange = (date: Date | null) => {
        setSelectedEndDate(date);
    };
    const options = [
        { value: "Choose", label: "Choose" },
        { value: "Sharon Roy", label: "Sharon Roy" },
        { value: "Darlee Robertson", label: "Darlee Robertson" },
        { value: "Robertson", label: "Robertson" },

    ]
    const options2 = [
        { value: "Choose", label: "Choose" },
        { value: "High", label: "High" },
        { value: "Low", label: "Low" },
        { value: "Medium", label: "Medium" },

    ]
    const options5 = [
        { value: "Choose", label: "Choose" },
        { value: "Upcoming", label: "Upcoming" },
        { value: "Canceled", label: "Canceled" },
        { value: "Completed", label: "Completed" },

    ]
    const options4 = [
        { value: "Choose", label: "Choose" },
        { value: "Client Home", label: "Client Home" },
        { value: "Client Office", label: "Client Office" },
        { value: "Client Site", label: "Client Site" },
        { value: "Remote", label: "Remote" },
        { value: "Virtual Meeting Room", label: "Virtual Meeting Room" },
    ]
    const options3 = [
        { value: "Choose", label: "Choose" },
        { value: "(GMT+01:00) United Kingdom Time", label: "(GMT+01:00) United Kingdom Time" },
        { value: "(GMT+01:00) United Kingdom Time", label: "(GMT+01:00) United Kingdom Time" },
        { value: "(GMT+01:00) United Kingdom Time", label: "(GMT+01:00) United Kingdom Time" },

    ]
    const options1 = [
        { value: "Select", label: "Select" },
        { value: "Client Meeting", label: "Client Meeting" },
        { value: "Product Demo", label: "Product Demo" },
        { value: "Project Update", label: "Project Update" },
        { value: "Technical Discussion", label: "Technical Discussion" },
        { value: "Team Meeting", label: "Team Meeting" },
        { value: "Market Analysis", label: "Market Analysis" },
        { value: "Budget Review", label: "Budget Review" },

    ];
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };

    return (
        <>
      
        <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
            <div className="sidebar-layout">
                <div className="sidebar-header">
                    <h4>{isEditing ? "Edit Meeting" : "Add Meeting"} </h4>
                    <Link to="#" className="sidebar-close toggle-btn" onClick={closeSidebar}>
                        <i className="ti ti-x" />
                    </Link>
                </div>
                <div className="toggle-body">
                    <div className="toggle-height height-inherit">
                        <div className="pro-create">
                            <div className="row">
                            <div className="col-md-12 mt-2">
                                    <label className="col-form-label">
                                        Meeting Title<span className="text-danger"> *</span>
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={options1}
                                    />
                                </div>
                                <div className="col-md-12 mt-3">
                                <label className="col-form-label">
                                        Date & Time<span className="text-danger"> *</span>
                                    </label>
                                    <div className="row align-items-center">
                                    <div className="col-md-3">
                                        <DatePicker
                                            className="form-control datetimepicker deals-details"
                                            selected={selectedStartDate}
                                            onChange={handleStartDateChange}
                                            dateFormat="dd-MM-yyyy"
                                            
                                        />
                                        </div>
                                        <div className="col-md-3">
                                        <TimePicker 
                                         placeholder="Select Time"
                                         className="form-control datetimepicker-time"
                                         onChange={onChangeStart}
                                         defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
                                          format="h:mm A"
                                          use12Hours
                                          />
                                        </div>
                                        <div className="col-md-1">
                                            <p className="mb-0">To</p>
                                        </div>
                                        <div className="col-md-3">
                                        <DatePicker
                                            className="form-control datetimepicker deals-details"
                                            selected={selectedEndDate}
                                            onChange={handleEndDateChange}
                                            dateFormat="dd-MM-yyyy"
                                            
                                        />
                                        </div>
                                        <div className="col-md-2">
                                        <TimePicker 
                                         placeholder="Select Time"
                                         className="form-control datetimepicker-time"
                                         onChange={onChangeEnd}
                                         defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
                                          format="h:mm A"
                                          use12Hours
                                          />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label className="col-form-label">
                                        Select Time Zone <span className="text-danger"> *</span>
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={options3}
                                    />
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label className="col-form-label">
                                       Location <span className="text-danger"> *</span>
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={options4}
                                    />
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label className="col-form-label">
                                       Host <span className="text-danger"> *</span>
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={options}
                                    />
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label className="col-form-label">
                                       Participants <span className="text-danger"> *</span>
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={options}
                                    />
                                </div>
                                <div className="col-md-6 mt-2">
                                    <label className="col-form-label">
                                       Status <span className="text-danger"> *</span>
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={options5}
                                    />
                                </div>
                                <div className="col-md-6 mt-2">
                                    <label className="col-form-label">
                                       Priority <span className="text-danger"> *</span>
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={options2}
                                    />
                                </div>
                            </div>      
                            </div>
                        </div>
                        <div className="submit-button text-end">
                            <Link to="#" className="btn btn-light sidebar-close" onClick={closeSidebar}>
                                Cancel
                            </Link>
                            <Link
                                to="#"
                                className="btn btn-primary"
                                data-bs-target="#create_project"
                            >
                                {isEditing ? "Update" : "Add"}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            </>
    );
};

export default MeetingSidebar;
